/** 0 -> 'just now', 42 -> '42m ago', 200 -> '3h ago', 3000 -> '2d ago'. */
export function relativeSeen(minutes) {
    if (minutes === null || minutes === undefined) return 'never';
    if (minutes < 1) return 'just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (minutes < 1440) return `${Math.floor(minutes / 60)}h ago`;
    return `${Math.floor(minutes / 1440)}d ago`;
}

/** Matches the old portal: green at 80%+, amber at 60%+, red below. */
export function utilisationTone(pct) {
    if (pct >= 80) return 'good';
    if (pct >= 60) return 'warn';
    return 'bad';
}

export const DEVICE_TONE = {
    active: 'good',
    idle: 'warn',
    online: 'good',
    locked: 'muted',
    suspended: 'muted',
    offline: 'bad',
    revoked: 'bad',
};

/** Triggers a browser download from an axios blob response. */
export function downloadBlob(data, filename) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}
